module.exports = __webpack_public_path__ + "static/media/cabecera_web_logo_MaaC.2cb32c23.png";